import Form from 'components/Form';

import { Fragment } from 'react';
import { Grid } from '@mui/material';

import RowContainer from '../components/RowContainer';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import { Stack } from '@mui/system';
import RowContent from '../components/RowContent';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  { label: '糖尿病', key: 'background_pmh.checked1' },
  { label: '充血性心力衰竭', key: 'background_pmh.checked2' },
  { label: '高血压', key: 'background_pmh.checked3' },
  { label: '冠状动脉疾病', key: 'background_pmh.checked4' },
  { label: '经皮冠状动脉介入治疗', key: 'background_pmh.checked5' },
  { label: '高脂血症', key: 'background_pmh.checked6' },
  { label: '外周血管疾病', key: 'background_pmh.checked7' },
  { label: '胃食管反流病', key: 'background_pmh.checked8' },
];

const checks2 = [
  { label: '慢性阻塞性肺疾病', key: 'background_pmh.checked9' },
  { label: '哮喘', key: 'background_pmh.checked10' },
  { label: '慢性肾病', key: 'background_pmh.checked11' },
  { label: '终末期肾病', key: 'background_pmh.checked12' },
  { label: '吸烟者', key: 'background_pmh.checked13' },
  { label: '药物滥用', key: 'background_pmh.checked14' },
  { label: '精神疾病', key: 'background_pmh.checked15' },
  { label: '脑血管意外', key: 'background_pmh.checked16' },
];

const checks3 = [
  { label: '痴呆', key: 'background_pmh.checked17' },
  { label: '甲状腺功能减退', key: 'background_pmh.checked18' },
  { label: '癌症', key: 'background_pmh.checked19' },
];

const checks_Tests = [
  { label: '磁共振成像', key: 'background_tests.checked1' },
  { label: 'X光', key: 'background_tests.checked2' },
  { label: '计算机断层扫描', key: 'background_tests.checked3' },
  { label: '内窥镜检查', key: 'background_tests.checked4' },
  { label: '超声波', key: 'background_tests.checked5' },
  { label: '导管插入术', key: 'background_tests.checked6' },
  { label: '超声心动图射血分数', key: 'background_tests.checked7' },
];

const Background = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="B (background, 背景)" />
      <RowContainer
        xs={12}
        sx={{ margin: '20px auto 20px auto', marginLeft: '-25px' }}
      >
        <RowContent title="PMH (既往病史)" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks.map((v, i) => {
              return (
                <Grid item xs={i === 7 ? 0.4 : 1.6}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks2.map((v, i) => {
              return (
                <Grid item xs={i === 7 ? 0.4 : 1.6}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks3.map((v, i) => {
              return (
                <Grid item xs={i === 7 ? 0.4 : 1.6}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="测试" titleRatio={1} childrenRatio={10.3}>
          <Stack direction="row" spacing={1}>
            {checks_Tests.map((v, i) => {
              if (i === 6) {
                return (
                  <Grid item xs={2.5}>
                    <Stack direction="row">
                      <Form.MuiCheckbox
                        label={v.label}
                        disabled={disabled}
                        defaultValue={
                          Boolean(getValues(v.key)) ? [v.label] : []
                        }
                        onChange={(_, checked) => {
                          setValue(v.key, checked);
                        }}
                      />
                      <Form.MuiTextField
                        required={false}
                        sx={{ width: '190px', marginLeft: '20px' }}
                        disabled={disabled}
                        placeholder="输入"
                        {...register(`background_tests_input`)}
                      />
                    </Stack>
                  </Grid>
                );
              }
              return (
                <Grid item xs={i === 7 ? 0.4 : 1.6}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Background;
